

export enum ChallengeStatusTypes {
    Unanswered,
    Answered,
    Closed,
    
}

